"use strict";

/**
 * @classdesc
 * Implementierung des FeatureInfo-Providers für interne Layer (d.h. Request gegen GeoCMS).
 *
 * @class
 * @extends gc.gis.module.GCFeatureInfoProvider
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.module.GCFeatureInfo} module Referenz auf das Feature-Info-Modul
 */
gc.gis.module.GCFeatureInfoProvider.OLInternalLayer = function(module)
{
    gc.gis.module.GCFeatureInfoProvider.call(this, module);
};
gc.gis.module.GCFeatureInfoProvider.OLInternalLayer.prototype = Object.create(gc.gis.module.GCFeatureInfoProvider.prototype);


/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfoProvider.OLInternalLayer.prototype.identify = function (layer, geometry, opt_limit)
{
    var self = this;

    if (opt_limit !== undefined && opt_limit < 1)
    {
        return;
    }

    var service = gc.gis.iface.serviceFactory.createQueryService(),
	    options = {};

	if (opt_limit)
	{
		options.limit = opt_limit;
	}

	service.on(gc.gis.service.FeatureServiceEvent.IDENTIFY_SUCCESS, this, function (evt) {
		self._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.IDENTIFYEND, {
			layer: layer,
			provider: self,
			features: self._buildFeatures(evt.features)
		});
	});
	service.on(gc.gis.service.FeatureServiceEvent.IDENTIFY_ERROR, this, function (evt) {
		self._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.IDENTIFYERROR, {
			layer: layer,
			provider: self,
			error: evt.error
		});
	});

    service.identify(
        layer,
        geometry,
        this.module.getMap().getViewportExtent(),
        this.module.getMap().getSize(),
	    options
    );

    this._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.IDENTIFYSTARTED, {
        layer: layer,
        provider: self
    });
};


/**
 * @inheritDoc
 */
gc.gis.module.GCFeatureInfoProvider.OLInternalLayer.prototype.renderDetail = function (layer, features)
{
	const self = this;

	if (!Array.isArray(features)) {
		features = [features];
	}

	this._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.DETAILSTART, {
		layer: layer,
		provider: self
	});

	for (let i = 0, ii = features.length; i<ii; i++)
	{
		// passendes Feature-Objekt binden über anonyme Funktion
		(function (layer, feature) {

			// Details sind bereits vorhanden => zurückgeben
			const result = feature.getAttribute('detailResult');
			if (result)
			{
				self._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.DETAILEND, {
					provider: self,
					layer: layer,
					feature: feature,
					detailResult: result
				});

				return;
			}

			const service = gc.gis.iface.serviceFactory.createQueryService();
			service.on(gc.gis.service.FeatureServiceEvent.IDENTIFY_DETAIL_SUCCESS, this, function (evt) {
				self._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.DETAILEND, {
					provider: self,
					layer: layer,
					feature: feature,
					detailResult: evt.detailResult
				});
			});
			service.on(gc.gis.service.FeatureServiceEvent.IDENTIFY_DETAIL_ERROR, this, function (evt) {
				self._fireEvent(gc.gis.module.GCFeatureInfoProviderEvent.DETAILERROR, {
					provider: self,
					layer: layer,
					feature: feature,
					error: evt.error
				});
			});
			service.identifyDetail(layer, feature.getID(), feature.getAttribute('featureLayer'));

		})(layer, features[i]);
	}
};

gc.gis.module.GCFeatureInfoProvider.OLInternalLayer.prototype._buildFeatures = function (features)
{
	var feature, i, ii,
		feature_list = [];

	for (i = 0, ii = features.length; i < ii; i++)
	{
		feature = gc.gis.iface.mapFactory.createFeature();
		feature.setID(features[i].getID());
		feature.setAttribute('title', features[i].getTitle());
		feature.setAttribute('featureLayer', features[i].getFeatureLayer());
		feature.setAttribute('isShowDetail', false);

		feature.setGeometry(features[i].getGeometry());
		feature.setAttribute('actions', features[i].getActions());
		feature.setAttribute('detailResult', features[i].getHTMLDetailResult());

		feature_list.push(feature);
	}

	return feature_list;
};